import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  Select,
  MenuItem,
  Grid,
  makeStyles,
} from "@material-ui/core";
import { setLanguage } from "redux/actions/appActions";
import i18n, { defaultLanguage } from "../i18n";
import { languageCodes } from "../config";

const useStyles = makeStyles((theme) => ({
  formControl: {
    borderWidth: 0,
    marginRight: theme.spacing(3),
    textTransform: "capitalize",
    overflow: "clip",
  },
  upper: {
    textTransform: "capitalize",
  },
  select: {
    maxHeight: "32px",
  },
}));

const LanguageSelection = () => {
  // set app language as per in app config.
  const { language } = useSelector((state) => state.appConfig);
  // set lang options
  const translation = useSelector((state) => state.translation);
  // Language options.
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [lng, setlng] = useState(i18n.language);
  const disabledLangKeys = ["version", "nl"];

  const keys =
    translation &&
    translation.i18n &&
    Object.keys(translation.i18n).filter(
      (data) => !disabledLangKeys.includes(data.toLowerCase())
    );

    useEffect(()=>{
    if(translation && translation.i18n ){
      let defLan = Object.keys(translation.i18n).filter((data) => data && i18n.language && !disabledLangKeys.includes(data.toLowerCase()) && data.toLowerCase() === i18n.language.toLowerCase());
      if(!defLan.length>0){
        setlng(languageCodes.english);
      }else{
        setlng(i18n.language);
      }
    }
    },[translation])

  // i18n
  let allLanguages = [
    {
      value: languageCodes.english,
      name: t("language.lblEnglish", { lng: languageCodes.english }),
    },
    {
      value: languageCodes.spanish,
      name: t("language.lblSpanish", { lng: languageCodes.spanish }),
    },
    {
      value: languageCodes.portuguese,
      name: t("language.lblPortuguese", { lng: languageCodes.portuguese }),
    },
    {
      value: languageCodes.german,
      name: t("language.lblGerman", { lng: languageCodes.german }),
    },
    // { value: languageCodes.dutch, name: t("language.lblDutch") },    // not required as part of Issue 119
    {
      value: languageCodes.french,
      name: t("language.lblFrench", { lng: languageCodes.french }),
    },
    {
      value: languageCodes.turkish,
      name: t("language.lblTurkish", { lng: languageCodes.turkish }),
    },
    {
      value: languageCodes.romanian,
      name: t("language.lblRomanian", { lng: languageCodes.romanian }),
    },
    {
      value: languageCodes.greek,
      name: t("language.lblGreek", { lng: languageCodes.greek }),
    },
    {
      value: languageCodes.russian,
      name: t("language.lblRussian", { lng: languageCodes.russian }),
    },
    {
      value: languageCodes.thai,
      name: t("language.lblThai", { lng: languageCodes.thai }),
    },
    {
      value: languageCodes.slovak,
      name: t("language.lblSlovak", { lng: languageCodes.slovak }),
    },
    {
      value: languageCodes.indonesian,
      name: t("language.lblIndonesian", { lng: languageCodes.indonesian }),
    },
    {
      value: languageCodes.serbian,
      name: t("other.lblSerbian", { lng: languageCodes.serbian }),
    },
    {
      value: languageCodes.bulgarian,
      name: t("other.lblBulgarian", { lng: languageCodes.bulgarian }),
    },
    {
      value: languageCodes.polish,
      name: t("other.lblPolish", { lng: languageCodes.polish }),
    },
    {
      value: languageCodes.taiwan,
      name: t("other.lblTaiwan", { lng: languageCodes.taiwan }),
    },
    {
      value: languageCodes.korean,
      name: t("other.lblKorean", { lng: languageCodes.korean }),
    },
    {
      value: languageCodes.chineseSimplified,
      name: t("other.lblChineseSimplified", {
        lng: languageCodes.chineseSimplified,
      }),
    },
  ];
  /**
   * set language in app config on app load
   * Check if the user detected language is available and set to same.
   * If not, then set default language.
   */
  // useEffect(() => {
  //   if (!language) {
  //     i18n.language =
  //       i18n.language.length > 2 ? i18n.language.substr(0, 2) : i18n.language;
  //     if (
  //       allLanguages.filter((item) => item.value == i18n.language).length !== 1
  //     )
  //       i18n.language = defaultLanguage;
  //     dispatch(setLanguage(i18n.language));
  //     setlng(i18n.language);
  //   }
  // }, []);

  useEffect(() => {
    console.log("curr Language=====", language);
    if (language) {
      i18n.changeLanguage(language);
      setlng(language);
    }
  }, [language]);

  // change handler for language selection
  const changeLanguage = (event) => {
    console.log("changeLanguage:", event.target.value);
    if (event.target.value) {
      setlng(event.target.value);
      // set language selection in app config
      dispatch(setLanguage(event.target.value));
    }
  };
  // i18n - end

  return (
    <Grid container justify="flex-end">
      <Grid item>
        {/* <div>HELLO justify</div> */}
        <FormControl
          className={classes.formControl}
          variant="outlined"
          size="small"
        >
          <Select
            value={lng}
            onChange={changeLanguage}
            className={classes.select}
          >
            {/* {
            allLanguages.map((language, idx) =>
             (
              <MenuItem
                key={idx}
                value={language.value}
                className={classes.upper}
              >
                {language.name}
              </MenuItem>
            ))} */}

            {translation &&
              translation.i18n &&
              Object.keys(translation.i18n).length > 0 &&keys&&
              keys.length > 0 &&
              keys.map((data) => (
                <MenuItem
                  key={data.toLowerCase()}
                  value={data.toLowerCase()}
                  className={classes.upper}
                >
                  {t("other.langLabel", { lng: data.toLowerCase() })}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

LanguageSelection.propTypes = {
  i18n: PropTypes.object.isRequired,
};

export default LanguageSelection;
